import type { NormalizedRedmineField } from '../../catalogs/types';
import type { Overviews } from '../../overviewattck/types';
import { getEntries, getValues } from '@/utils';

export const redmineEntityToArr = (arr: NormalizedRedmineField) =>
  arr && arr.length ? arr.map((el) => `${el.name} (${el.amount})`) : [];

// Pulls just the display names from a NormalizedRedmineField (no `(amount)`
// suffix). Used by the metadata header, EntityChips and ReportFooter.
export const redmineNamesToArr = (arr: NormalizedRedmineField | undefined | null): string[] =>
  arr && arr.length ? arr.map((el) => el.name) : [];

// Accepts either a NormalizedRedmineField array or the legacy object form
// (id → name map). Returns the list of display names.
export const toNamesArr = (
  value: NormalizedRedmineField | Record<string, unknown> | undefined | null
): string[] => {
  if (!value) return [];
  if (Array.isArray(value)) return redmineNamesToArr(value);
  return getValues(value).map((v) => String(v));
};

// Extracts a flat list of MITRE technique names from an ATT&CK overview blob.
// Used by EntityChips to render the "ATT&CK Techniques" chips block alongside
// the table view rendered in ReportFooter.
export const attckTechniquesToNames = (overviews: Overviews | undefined | null): string[] => {
  if (!overviews) return [];
  return getEntries(overviews).flatMap(([, value]) => value.map((o) => o.mitre_name));
};
